import {
  ArrowRightLeft,
  Briefcase,
  Building2,
  CalendarDays,
  FileText,
  Home,
  Shield,
  Users,
} from 'lucide-react';
import { Link } from 'react-router-dom';

import { BrandMark } from '@/components/BrandMark';
import { SidebarMenu, SidebarMenuButton, SidebarMenuItem } from '@/components/ui/sidebar';
import { useRoleSwitcher } from '@/hooks/useRoleSwitcher';

import { PortalLayout, type NavSection, type PortalMenuItem } from './PortalLayout';

const NAV_SECTIONS: NavSection[] = [
  {
    label: 'Navigation',
    items: [
      { to: '/enterprise', label: 'Home', icon: Home, end: true },
      { to: '/enterprise/visitors', label: 'Visitors', icon: Users },
      { to: '/enterprise/events', label: 'Events', icon: CalendarDays },
      { to: '/enterprise/history', label: 'Visitor History', icon: FileText },
      { to: '/enterprise/worker-passes', label: 'Worker Passes', icon: Briefcase },
      { to: '/enterprise/employees', label: 'Employees', icon: Users },
    ],
  },
  {
    label: 'Company',
    items: [{ to: '/enterprise/account', label: 'Company Account', icon: Building2 }],
  },
];

const MENU_ITEMS: PortalMenuItem[] = [
  { to: '/enterprise/account', label: 'Company Account', icon: Building2 },
  { to: '/enterprise/account/privacy', label: 'Privacy & Data', icon: Shield },
];

const ROLE_LABELS: Record<string, string> = {
  resident: 'Resident',
  property_manager: 'Manager',
  security_supervisor: 'Supervisor',
  enterprise_tenant_admin: 'Enterprise Admin',
  employee: 'Employee',
  guard: 'Guard',
  org_admin: 'Org Admin',
};

const BRAND = (
  <SidebarMenu>
    <SidebarMenuItem>
      <SidebarMenuButton size="lg" asChild>
        <Link to="/enterprise">
          <BrandMark className="size-8 shrink-0" aria-hidden />
          <span className="font-semibold tracking-tight">Secure Labs</span>
        </Link>
      </SidebarMenuButton>
    </SidebarMenuItem>
  </SidebarMenu>
);

export function EnterpriseLayout() {
  const { switchableRoles, switchTo, hasMultipleRoles } =
    useRoleSwitcher('enterprise_tenant_admin');

  const menuItems: PortalMenuItem[] = [
    ...MENU_ITEMS,
    ...switchableRoles.map((sr) => ({
      to: sr.dashboard,
      label: `Switch to ${ROLE_LABELS[sr.role] ?? sr.role}`,
      icon: ArrowRightLeft,
      onClick: () => switchTo(sr),
    })),
  ];

  return (
    <PortalLayout
      brand={BRAND}
      navSections={NAV_SECTIONS}
      notificationsTo="/enterprise/notifications"
      menuItems={hasMultipleRoles ? menuItems : MENU_ITEMS}
    />
  );
}
